// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DiagnosisSearchRequestModel {
    static getAttributeTypeMap() {
        return DiagnosisSearchRequestModel.attributeTypeMap;
    }
}
DiagnosisSearchRequestModel.discriminator = undefined;
DiagnosisSearchRequestModel.attributeTypeMap = [
    {
        "name": "programId",
        "baseName": "programId",
        "type": "number"
    },
    {
        "name": "diagnosisName",
        "baseName": "diagnosisName",
        "type": "string"
    },
    {
        "name": "diagnosisDescription",
        "baseName": "diagnosisDescription",
        "type": "string"
    },
    {
        "name": "diagnosisCode",
        "baseName": "diagnosisCode",
        "type": "string"
    },
    {
        "name": "diagnosisType",
        "baseName": "diagnosisType",
        "type": "DiagnosisType"
    },
    {
        "name": "maxRecordCount",
        "baseName": "maxRecordCount",
        "type": "number"
    }
];
//# sourceMappingURL=diagnosisSearchRequestModel.js.map